import { FormattedMessage } from "react-intl";
import { useClientDiscardedValuations } from "../../features/valuation";
import DiscardedValuationsTable from "./DiscardedValuationsTable";

interface IClientDiscardedValuationsTableProps {
  candidateId: string;
}

const ClientDiscardedValuationsTable = (
  props: IClientDiscardedValuationsTableProps
) => {
  const { candidateId } = props;

  const valuationsQuery = useClientDiscardedValuations({
    params: { candidateId },
  });

  return (
    <DiscardedValuationsTable
      status={valuationsQuery.status}
      rows={valuationsQuery.data?.["hydra:member"].map((valuation) => ({
        id: valuation.id,
        contratoName: valuation.contratoName,
        statusUpdatedAt: valuation.statusUpdatedAt,
        reason: valuation.discard_reason,
      }))}
      emptyMessage={
        <FormattedMessage
          id="ClientDiscardedValuationsTable.Ningún cliente ha descartado a este candidato/a"
          defaultMessage="Ningún cliente ha descartado a este candidato/a"
        />
      }
    />
  );
};

export default ClientDiscardedValuationsTable;
